/**
 * Remaining balance for an order (grand_total minus payments applied).
 * Matches StandardOrderCheckout: sum uses amount_paid when set, else amount.
 */
export function getOrderRemainingBalance(order) {
  if (!order) return 0;
  const total = parseFloat(order.grand_total);
  if (Number.isNaN(total)) return 0;
  let paid = 0;
  if (Array.isArray(order.payments)) {
    order.payments.forEach((p) => {
      const ap =
        p.amount_paid != null ? parseFloat(p.amount_paid) : parseFloat(p.amount);
      paid += Number.isNaN(ap) ? 0 : ap;
    });
  }
  return parseFloat((total - paid).toFixed(2));
}
